// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import PartialDebitModal from '../../../shared/components/debit-modal';

function closePartialDebitModal() {

    this.actions.updatePartialDebitModalVisibility(false);

}

function handleConfirm() {

    this.actions.updatePartialDebit(this.debit, this.queryParams.auditNumber);

}

function handleCommentsChange(comments) {

    this.actions.updatePartialDebitComments(comments);

}

const PartialDebitModalContainer = props =>
    <PartialDebitModal
        busyCounter={props.busyCounter}
        closeModal={props::closePartialDebitModal}
        debit={props.debit}
        debitType='PARTIAL'
        isModalVisible={props.isPartialDebitModalVisible}
        onCommentsChange={props::handleCommentsChange}
        onConfirmation={props::handleConfirm}
    />;

PartialDebitModalContainer.displayName = 'PartialDebitModal';
PartialDebitModalContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    isPartialDebitModalVisible: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default PartialDebitModalContainer;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/partial-debit-modal/partial-debit-modal-container.js